"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ControlMessage_1 = __importDefault(require("../ControlMessage"));
const validations_1 = require("../../../utils/validations");
const StreamMessage_1 = __importDefault(require("../../message_layer/StreamMessage"));
class BroadcastMessage extends ControlMessage_1.default {
    constructor({ version = ControlMessage_1.default.LATEST_VERSION, requestId, streamMessage }) {
        super(version, ControlMessage_1.default.TYPES.BroadcastMessage, requestId);
        (0, validations_1.validateIsType)('streamMessage', streamMessage, 'StreamMessage', StreamMessage_1.default);
        this.streamMessage = streamMessage;
    }
}
exports.default = BroadcastMessage;
//# sourceMappingURL=BroadcastMessage.js.map